import { ReactNode, Suspense } from 'react';

import { IconsId } from '@/types/icons';

import { ButtonClient } from './client/ButtonClient';
import { ButtonServer } from './server/ButtonServer';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    iconName?: IconsId;
    hideArrow?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ children, iconName, hideArrow = false, className, ...props }) => (
    <Suspense
        fallback={
            <ButtonServer
                {...props}
                iconName={iconName}
                hideArrow={hideArrow}
                className={className}
            >
                {children}
            </ButtonServer>
        }
    >
        <ButtonClient
            {...props}
            iconName={iconName}
            hideArrow={hideArrow}
            className={className}
        >
            {children}
        </ButtonClient>
    </Suspense>
);
